import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

// Criação do contexto
const ModalContext = createContext(null);

// Provider do contexto
export const ModalProvider = ({ children, value }) => {
  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

// Hook personalizado para uso do contexto
export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (context === null) {
    throw new Error('useModalContext must be used within a ModalProvider');
  }
  return context;
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.shape({
    onClose: PropTypes.func.isRequired,
  }).isRequired,
};